import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../../common/Bold";
import { LiItem } from "../../common/LiItem";
export var SOYOProcessing = function SOYOProcessing() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "M5A5R8",
    defaultMessage: [{
      "type": 0,
      "value": "Volg deze stappen om de trackinginformatie bij te werken voor een bestelling die nog niet is verzonden:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JUmURU",
    defaultMessage: [{
      "type": 0,
      "value": "Ga naar het tabblad Bestellingen en selecteer de bestelling die je wilt bijwerken."
    }]
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "hsC0PT",
    defaultMessage: [{
      "type": 0,
      "value": "Kies op de pagina met bestelgegevens de optie Bewerken naast de verzendgegevens."
    }]
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "If87ZM",
    defaultMessage: [{
      "type": 0,
      "value": "Werk de benodigde verzendgegevens bij, zoals vervoerder, trackingnummer en verwachte verzenddatum."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "noKs1A",
    defaultMessage: [{
      "type": 0,
      "value": "We raden je ook aan om je retailer op de hoogte te stellen van de wijzigingen in de verzendgegevens via "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire Messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " om verwarring te voorkomen."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  })));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};